export default "__VITE_ASSET__6bb2be17__"